import React, { ReactNode } from "react"
import { Link } from "react-router-dom"

interface WLinkProps {
    to: string
    children?: ReactNode
}

const WLink: React.FC<WLinkProps> = ({ to, children }) => {
    return <Link
        to={to}
        className="nav-link active"
    >
        {children}
    </Link>
}


export { WLink }
